import type { HTMLAttributeAnchorTarget } from 'react'
import type { MemberRole } from '@/lib/auth/types'
import type { Entitlement } from '@/lib/polar/types'

export type TSidebarItem = {
  id?: string
  title: string
  tooltip?: string
  url: string
  subItems?: TSidebarItem[]
  icon?: React.ElementType
  noPrefetch?: boolean
  target?: HTMLAttributeAnchorTarget
  // Visibility permissions
  permissions?: {
    roles?: MemberRole[]
    entitlements?: Entitlement[]
    orgIds?: string[]
  }
}

export enum SidebarSection {
  MAIN_MY_ASSETS = 'MAIN_MY_ASSETS',
  MAIN_PROSPECTING = 'MAIN_PROSPECTING',
  MAIN_OPPORTUNITIES = 'MAIN_OPPORTUNITIES',
  MAIN_MONITORING = 'MAIN_MONITORING',
  ORG = 'ORG',
  SECONDARY = 'SECONDARY',
}
